import {
  ADD_SPATIAL,
  UPDATE_SPATIAL,
  REMOVE_SPATIAL,
  CREATE_SPATIAL,
  EDIT_SPATIAL,
  CLEAR_SELECTED_SPATIAL,
  SUBMIT_SPATIIAL,
  TOGGLE_EDIT_SPATIAL,
  SUBMIT_CHANGES_TO_SPATIAL,
  TOGGLE_ACTIVE_TOOLS,
} from './constants'

export function addSpatial ({spatial}) {
  return {
    type: ADD_SPATIAL,
    payload: {spatial},
  }
}

export function updateSpatial ({spatial}) {
  return {
    type: UPDATE_SPATIAL,
    payload: {spatial},
  }
}

export function removeSpatial ({spatial}) {
  return {
    type: REMOVE_SPATIAL,
    payload: {spatial},
  }
}

export function createSpatial ({spatial}) {
  return {
    type: CREATE_SPATIAL,
    payload: {spatial},
  }
}

export function editSpatial ({spatial}) {
  return {
    type: EDIT_SPATIAL,
    payload: {spatial},
  }
}

export function clearSelectedSpatial ({spatial}) {
  return {
    type: CLEAR_SELECTED_SPATIAL,
    payload: {spatial},
  }
}

export function submitSpatial ({spatial}) {
  return {
    type: SUBMIT_SPATIIAL,
    payload: {spatial},
  }
}

export function toggleEditingSpatial () {
  return {
    type: TOGGLE_EDIT_SPATIAL,
  }
}

export function submitChangesToSpatial (operation) {
  return {
    type: SUBMIT_CHANGES_TO_SPATIAL,
    payload: operation,
  }
}

export function toggleActiveToolsOp (isActiveOp) {
  return {
    type: TOGGLE_ACTIVE_TOOLS,
    payload: isActiveOp,
  }
}
